module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d6WQ6"))).then(() => parcelRequire('37nVf'));